<template>
  <div v-if="message" class="messages h5 fw-normal mb-0" :class="[status ? status : '']">
    {{ $t(`messages.${message}`) }}
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useMessageStore } from '@/store/message.store';
const messageStore = useMessageStore();
const message = computed(() => messageStore.getMessage);
const status = computed(() => {
  return `messages--${messageStore.getStatus}`;
});
</script>
<style scoped>
.messages {
  padding: 15px 20px 15px 35px;
  word-wrap: break-word;
  border: 1px solid;
  border-width: 0 0 1px 0;
  border-radius: 2px;
  background: no-repeat 10px 17px;
  overflow-wrap: break-word;
}

.messages--error {
  color: #a51b00;
  border-color: transparent transparent #f9c9bf transparent;
  background-color: #fcf4f2;
}
</style>